
import React, { useState,useEffect } from "react";
import { Container, Row, Col, Form, Button,Image } from "react-bootstrap";
import man from "../assets/girl.png";
import massaage from "../assets/DSC03537-removebg-preview 1.png"
import cleaner from "../assets/cleaner3.png"
import styles from "./Landing.module.css";

export default function LandingPage() {
  const [validated, setValidated] = useState(false);

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }

    setValidated(true);
  };

  const [currentIndex, setCurrentIndex] = useState(0);

  const slides = [
    { image: man },
    { image: massaage },
    { image: cleaner },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % slides.length);
    }, 5000); // 5 seconds

    return () => clearInterval(interval);
  }, [slides.length]);
  
  return (
    <div className={styles.container}>
      <div className={styles.containerrow}>
        <div className={styles.containercol1}>
          <div style={{ width: "90%" }}>
            <h1 className={styles.headingoflanding}>
              Book your Home
              Services in Minutes
            </h1>
               <br></br>
            <div className={styles.formbox}>
              <Form noValidate validated={validated} onSubmit={handleSubmit} style={{marginTop:12}}>
                <Row className="mb-3">
                  <Form.Group as={Col} md="12" controlId="validationCustom01">
                    <Form.Control
                      required
                      type="text"
                      placeholder="Name"
                      className={styles.inputBox}
                      style={{background:"transparent",border:"none",borderBottom:"1px solid #767676",borderRadius:0,fontFamily:"sans-serif",fontSize:14}}
                    />
                  </Form.Group>
                </Row>

                <Row className="mb-3">
                  <Form.Group as={Col} md="12" controlId="validationCustom01">
                    <Form.Control
                      required
                      type="text"
                      placeholder="Phone"
                      style={{background:"transparent",border:"none",borderBottom:"1px solid #767676",borderRadius:0,fontFamily:"sans-serif",fontSize:14}}
                    />
                  </Form.Group>
                </Row>

                <Row className="mb-3">
                  <Form.Group as={Col} md="12" controlId="validationCustom01">
                    <Form.Control
                      required
                      type="text"
                      placeholder="Email"
                      style={{background:"transparent",border:"none",borderBottom:"1px solid #767676",borderRadius:0,fontFamily:"sans-serif",fontSize:14}}
                    />
                  </Form.Group>
                </Row>

                <Button type="submit" className={"mx-auto d-block"} style={{background:"#66d6ff",border:"none",fontFamily:"Inter"}} >Quick Booking</Button>
              </Form>
            </div>
          </div>
        </div>
        <div className={styles.containercol2} style={{ position: "relative", overflow: "hidden" }}>
        {slides.map((slide, index) => (
            <div
              key={index}
              style={{
                width: "100%",
                height: "100%",
                flexDirection: "column",
                display: index === currentIndex ? "flex" : "none",
                justifyContent: "center",
                alignItems: "center",
                transition: "all 1s ease-in-out",
              }}
            >
              <Image cover    src={slide.image} alt="slide" className={styles.imggirl} fluid/>
            </div>
          ))}
         
         
        </div>
      </div>
    </div>
  );
}
